import React from 'react'
import ViewActionIcon from 'icons/ViewActionIcon'
import EditActionIcon from 'icons/EditActionIcon'
import DeleteActionIcon from 'icons/DeleteActionIcon'

export const rowActions = ({ canEdit, canDelete, navigate, selectRow, detailsUrl }) =>
  [
    {
      label: 'Details',
      labelColor: 'white',
      typographyVariant: 'medium',
      desktopIcon: <ViewActionIcon />,
      onClick: (_e, rowId) => navigate(`${detailsUrl}/${rowId}`)
    },
    canEdit && {
      label: 'Edit',
      labelColor: 'white',
      typographyVariant: 'medium',
      desktopIcon: <EditActionIcon />,
      onClick: (_e, rowId) => selectRow(rowId, 'edit')
    },
    canDelete && {
      label: 'Delete',
      labelColor: 'white',
      typographyVariant: 'medium',
      desktopIcon: <DeleteActionIcon />,
      onClick: (_e, rowId) => selectRow(rowId, 'delete')
    }
  ].filter(Boolean) // Filter out false values if canEdit or canDelete is false
